import { post } from '@/utils/request'

export const getAllCommodities = (p) => post('/commodity/getAllCommodities', p)
export const getMyCommodities = (p) => post('/commodity/getMyCommodities', p)
export const getApproveCommodities = (p) => post('/commodity/getApproveCommodities', p)
export const getOrderedCommodities = (p) => post('/commodity/getOrderedCommodities', p)
export const saveCommodity = (p) => post('/commodity/saveCommodity', p)
export const saveCommodityShowOrder = (p) => post('/commodity/saveCommodityShowOrder', p)
export const delCommodity = (p) => post('/commodity/delCommodity', p)
export const batchApprove = (p) => post('/commodity/batchApprove', p)
export const getCommodityDetail = (p) => post('/commodity/getCommodityDetail', p)
export const batchCancelApprove = (p) => post('/commodity/batchCancelApprove', p)